const buildDateRangeQuery = (startISO?: string, endISO?: string) => {
  if (!startISO || !endISO) return '';

  return `&bp_start_date=${encodeURIComponent(
    startISO,
  )}&bp_end_date=${encodeURIComponent(endISO)}`;
};

  const getCompletedOrders = async (
  axiosprivate: any,
  currentpage: number,
  auth: any,
  startISO?: string,
  endISO?: string,
) => {
  const response = await axiosprivate.get(
    `bp_get_completed_orders_information?page=${currentpage}${buildDateRangeQuery(
      startISO,
      endISO,
    )}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  console.log('response', response);
  return response;
};
const getPartialOrders = async (
  axiosprivate: any,
  currentpage: number,
  auth: any,
  startISO?: string,
  endISO?: string,
) => {
  const response = await axiosprivate.get(
    `bp_get_partial_orders_information?page=${currentpage}${buildDateRangeQuery(
      startISO,
      endISO,
    )}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  console.log('response', response);
  return response;
};

const getFilteredOrderswithStatus = async (
  axiosprivate: any,
  currentpage: number,
  auth: any,
  searchText: string,
  status: string,
) => {
  const response = await axiosprivate.get(
    `bp_search_order_by_receipt_id_information?page=${currentpage}&search_term=${searchText}&order_status=${status}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  console.log('response', response);
  return response;
};

const getPendingOrders = async (
  axiosprivate: any,
  currentpage: number,
  auth: any,
  startISO?: string,
  endISO?: string,
) => {
  const response = await axiosprivate.get(
    `bp_get_pending_orders_information?page=${currentpage}${buildDateRangeQuery(
      startISO,
      endISO,
    )}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const getEmployeeRecentOrders = async (
  axiosprivate: any,
  page: number,
  limit: number,
  auth: { accessToken?: string | null },
) => {
  return axiosprivate.get(
    `bp_get_recent_orders_information?page=${page}&limit=${limit}`,
    {
      headers: { Authorization: 'Bearer ' + String(auth?.accessToken || '') },
    },
  );
};

export const buildOrderStreamUrl = (
  baseUrl: string,
  accessToken: string,
  locationId: string,
) => {
  const root = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const path = `${root}/bp_employee_orders_stream`;
  const params = [
    `token=${encodeURIComponent(accessToken)}`,
    `location_id=${encodeURIComponent(locationId)}`,
  ];
  return `${path}?${params.join('&')}`;
};

export {
  getCompletedOrders,
  getPendingOrders,
  getFilteredOrderswithStatus,
  getPartialOrders,
  getEmployeeRecentOrders,
};

export interface CustomerOrderSummary {
  _id: string;
  bp_customer_name: string;
  bp_order_count: number;
}

export const getCustomerOrderSummaries = async (
  axiosprivate: any,
  locationId: string,
  auth: { accessToken?: string | null },
  page = 1,
  limit = 200,
): Promise<{ customers: CustomerOrderSummary[]; total: number }> => {
  try {
    const res = await axiosprivate.get(
      `bp_get_customers_order_summary?location_id=${encodeURIComponent(
        locationId,
      )}&page=${Math.max(1, page)}&limit=${Math.min(200, Math.max(1, limit))}`,
      {
        headers: {
          Authorization: 'Bearer ' + String(auth?.accessToken || ''),
        },
      },
    );
    const d = res?.data;
    return {
      customers: Array.isArray(d?.customers) ? d.customers : [],
      total: Number(d?.total ?? 0),
    };
  } catch {
    return { customers: [], total: 0 };
  }
};

// Types and helpers for service display streaming
// Service status update API
export const updateServiceStatus = async (
  axiosprivate: any,
  auth: any,
  params: {
    orderId: string;
    status: 'pending' | 'preparing' | 'completed';
    locationId?: string | null;
  },
) => {
  const statusUpper = (params.status || 'pending').toUpperCase();
  const response = await axiosprivate.patch(
    `bp_update_service_display_status`,
    { order_id: params.orderId, status: statusUpper },
    {
      headers: {
        Authorization: 'Bearer ' + auth?.accessToken,
        'Content-Type': 'application/json',
        'x-location-id': String(params.locationId || ''),
      },
    },
  );
  return response?.data;
};

export type ServiceStreamEvent = {
  type:
    | 'init'
    | 'order:new'
    | 'order:update'
    | 'service:update'
    | 'ping'
    | 'update'
    | 'delete'
    | 'heartbeat'
    | 'error'
    | string;
  payload?: any;
};

export const buildServiceStreamUrl = (
  baseUrl: string,
  locationId?: string | null,
  date?: string,
) => {
  const root = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const path = `${root}/bp_service_display_stream`;
  const params: string[] = [];
  // Keep server default limit behavior explicit
  params.push(`limit=200`);
  if (locationId) params.push(`location_id=${encodeURIComponent(locationId)}`);
  if (date) params.push(`date=${encodeURIComponent(date)}`);
  return params.length ? `${path}?${params.join('&')}` : path;
};
